// Report-param grammar for the emotional-dial block: emd<key> holds the view mode, the line mode
// and the persisted video position as one object. Ported from the coffee block
// (importReportParams / updateReportParams), which read it off the retired EmotionalDial.Lib.

export const DEFAULT_OPTIONS = { viewMode: 'windmap', lineMode: 'precise', videoTime: 0 }

// A stored section answers for all three values; a missing key inside it is not defaulted, so a
// half-written section reads back exactly as it was stored.
export const resolveReportParams = ({ section } = {}) =>
  undefined === section
    ? { ...DEFAULT_OPTIONS }
    : { viewMode: section.viewMode, lineMode: section.lineMode, videoTime: section.videoTime }

export const calcReportParamsSection = ({ viewMode, lineMode, videoTime } = {}) => {
  const section = { viewMode, lineMode, videoTime }

  const isDefault = Object.keys(DEFAULT_OPTIONS).every(key => section[key] === DEFAULT_OPTIONS[key])

  return isDefault ? null : section
}
